<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:10px">
        <v-card-title class="pa-0 ma-0">
          <v-toolbar
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            color="primary"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left color="white">fa-check-double</v-icon>Finalizar partida
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="dialog=false, endingKind='normal'">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="endingKind" column hide-details class="mt-0">
            Encerrar
            <v-radio color="primary" label="Normalmente" value="normal"></v-radio>
            <v-radio
              color="primary"
              label="Por W.O."
              value="w.o"
              :disabled="scoreA > 0? true : false || scoreB >0? true : false || tieBreakersA >0? true : false || tieBreakersB >0? true : false"
            ></v-radio>
            <v-radio
              color="primary"
              label="Número insuficiente de atletas"
              value="number of players"
              :disabled="tieBreakersA >0? true : false || tieBreakersB >0? true : false"
            ></v-radio>
          </v-radio-group>

          <!-- CASE NORMAL -->
          <template v-if="endingKind == 'normal'">
            <v-divider class="mt-3"></v-divider>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-layout row wrap justify-space-around align-center class="mt-3">
              <v-flex xs4 text-xs-center>
                <v-avatar :size="70" color="white">
                  <v-icon v-if="!homeTeam.team_logo" :size="56" color="grey lighten-1">fa-shield-alt</v-icon>
                  <v-img
                    v-if="homeTeam.team_logo"
                    aspect-ratio="1"
                    style="border-radius: 12px"
                    contain
                    :src="homeTeam.team_logo"
                    alt="alt"
                  />
                </v-avatar>
                <h4 class="text-xs-center">{{homeTeam.team_name}}</h4>
                <v-text-field
                  class="mt-1 headline"
                  outline
                  hide-details
                  :value="scoreA"
                  readonly
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <div class="display-1">X</div>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <v-avatar :size="70" color="white">
                  <v-icon v-if="!awayTeam.team_logo" :size="56" color="grey lighten-1">fa-shield-alt</v-icon>
                  <v-img
                    v-if="awayTeam.team_logo"
                    aspect-ratio="1"
                    style="border-radius: 12px"
                    contain
                    :src="awayTeam.team_logo"
                    alt="alt"
                  />
                </v-avatar>
                <h4 class="text-xs-center">{{awayTeam.team_name}}</h4>
                <v-text-field
                  class="mt-1 headline"
                  outline
                  hide-details
                  :value="scoreB"
                  readonly
                  single-line
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-card class="elevation-0" v-if="tieBreakersA!=0 || tieBreakersB != 0">
              <v-card-text>
                <v-layout row wrap justify-space-around align-center>
                  <v-flex xs4 text-xs-center class="title">+ {{tieBreakersA}}</v-flex>
                  <v-flex xs4 text-xs-center class="title">Desempate</v-flex>
                  <v-flex xs4 text-xs-center class="title">+ {{tieBreakersB}}</v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </template>

          <!--  CASE WO -->
          <template v-if="endingKind == 'w.o'">
            <v-radio-group v-model="winnerId" column hide-details>
              <v-divider></v-divider>
              <v-divider></v-divider>
              <v-divider></v-divider>Vencedor
              <v-radio color="primary" :label="homeTeam.team_name" :value="0"></v-radio>
              <v-radio color="primary" :label="awayTeam.team_name" :value="1"></v-radio>
            </v-radio-group>
            <template v-if="winnerId != null">
              <v-text-field
                v-model="winnerGoals"
                type="tel"
                mask="##"
                prepend-icon="mdi-soccer"
                label="Gols"
                hint="Gols do vencedor segundo o regulamento"
              ></v-text-field>
            </template>
          </template>

          <!-- CASE NUMBER PLAYERS -->
          <template v-if="endingKind == 'number'">
            <v-checkbox
              label="Manter resultado atual"
              v-model="currentResult"
              :value="true"
              hide-details
              color="primary"
            ></v-checkbox>
            <template v-if="!currentResult">
              <v-radio-group v-model="winnerId" column hide-details class="mt-0">
                <v-divider></v-divider>
                <v-divider></v-divider>
                <v-divider></v-divider>Vencedor
                <v-radio color="primary" :label="homeTeam.team_name" :value="0"></v-radio>
                <v-radio color="primary" :label="awayTeam.team_name" :value="1"></v-radio>
              </v-radio-group>
              <template v-if="winnerId!=null">
                <v-text-field
                  v-model="winnerGoals"
                  type="tel"
                  mask="##"
                  prepend-icon="mdi-soccer"
                  label="Gols"
                  hint="Gols do vencedor segundo o regulamento"
                ></v-text-field>
              </template>
            </template>
          </template>
        </v-card-text>

        <!-- SUBMIT -->
        <v-card-actions class="justify-end">
          <v-btn :disabled="!can_end_match" round text color="primary" @click="prepareResult()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Button Dialog -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn block @click="dialog=true" class="primary--text" color="light-green accent-3">
          <v-icon left dark color="white">fa-check-double</v-icon>Finalizar Partida
        </v-btn>
      </v-flex>
    </v-layout>
    <card-loading v-if="loading" :loadText="loadTxt"></card-loading>
  </div>
</template>


<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      loadText: "",
      dialog: false,
      endingKind: "normal",
      winnerId: 0,
      winnerGoals: 0,
      currentResult: true
    };
  },
  methods: {
    prepareResult() {
      let matchResult = [];

      //NORMAL
      if (this.endingKind == "normal") {
        matchResult = this.goalPapers
          .concat(this.cardPapers)
          .concat(this.breakerPapers);
      }

      // WO
      else if (this.endingKind == "w.o") {
        if (!this.winnerGoals) {
          this.winnerGoals = 0;
        }
        let goals = [];
        for (let g = 0; g < this.winnerGoals; g++) {
          const paper = {};
          paper.event_time = null;
          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = null;
          paper.champ_team_id =
            this.winnerId == 0 ? this.homeTeam.id : this.awayTeam.id;
          paper.kind = "gol";
          goals.push(paper);
        }
        matchResult = goals;
      }

      // NUMBER PLAYERS   --E DUVIDA SOBRE QUANDO O NAO MANTEM O RESULTADO - os Players que fizeram o gol perderiam seus gols se setados manualmente?
      else if (this.endingKind == "number of players") {
        if (this.currentResult) {
          matchResult = this.goalPapers.concat(this.cardPapers);
        } else {
          if (!this.winnerGoals) {
            this.winnerGoals = 0;
          }
          let goals = [];
          for (let g = 0; g < this.winnerGoals; g++) {
            const paper = {};
            paper.event_time = null;
            paper.match_id = this.oneMatch.data.id;
            paper.squad_number_id = null;
            paper.champ_team_id =
              this.winnerId == 0 ? this.homeTeam.id : this.awayTeam.id;
            paper.kind = "gol";
            goals.push(paper);
          }
          matchResult = goals;
        }
      }

      this.confirm(matchResult);
    },
    confirm(matchResult) {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Deseja finalizar a partida?",
          text: "Não é possível reverter essa ação",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          this.dialog = false;
          this.postResult(matchResult);
        }
      })();
    },
    postResult(matchResult) {
      return this.$http
        .put(`api/v1/matches/${this.oneMatch.data.id}`, {
          match: {
            id: this.oneMatch.data.attributes.id,
            ended: true,
            ended_at: new Date(),
            ended_as: this.endingKind,
            papers_attributes: matchResult
          }
        })
        .then(response => {
          console.log(response);
          this.showMatch(this.$router.currentRoute.params.id);
        })
        .catch(error => {
          console.log({ error });
        });
    },

    ...mapActions({
      createPaper: "Match/createPaper",
      showMatch: "Match/show"
    })
  },
  computed: {
    scoreA() {
      var filtered = [];
      if (this.goalPapers) {
        filtered = this.goalPapers.filter(obj => {
          return obj.champ_team_id === this.homeTeam.id;
        });
      }
      return filtered.length;
    },
    scoreB() {
      var filtered = [];
      if (this.goalPapers) {
        filtered = this.goalPapers.filter(obj => {
          return obj.champ_team_id === this.awayTeam.id;
        });
      }
      return filtered.length;
    },
    tieBreakersA() {
      var filtered = [];
      if (this.breakerPapers) {
        filtered = this.breakerPapers.filter(obj => {
          return obj.champ_team_id === this.homeTeam.id;
        });
      }
      return filtered.length;
    },
    tieBreakersB() {
      var filtered = [];
      if (this.breakerPapers) {
        filtered = this.breakerPapers.filter(obj => {
          return obj.champ_team_id === this.awayTeam.id;
        });
      }
      return filtered.length;
    },
    ...mapState({
      oneMatch: state => state.Match.oneMatch,
      goalPapers: state => state.Match.goalPapers,
      cardPapers: state => state.Match.cardPapers,
      breakerPapers: state => state.Match.breakerPapers
    }),
    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    }),
    can_end_match() {
      let aux = false;
      if (this.dialog) {
        if (this.ending_kind != "normal") {
          aux = true;
        } else if (
          this.ending_kind == "number of players" &&
          this.currentResult &&
          this.winnerGoals
        ) {
          aux = true;
        } else if (this.ending_kind == "w.o" && this.winner_goals) {
          aux = true;
        }
        return aux;
      }
    }
  }
};
</script>

<style scoped>
</style>